export const GOOGLE_MAPS_API_KEY = 'AIzaSyAaHX1-_vHykUyMadHjD4m6F-Csqu-0AsY';
export const DEFAULT_PAGE_SIZE = 9;
export const API_BASE_URL = 'https://api.routesonar.com';

export default { GOOGLE_MAPS_API_KEY, DEFAULT_PAGE_SIZE };
